import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import SwiperCore, { Navigation, Pagination, Swiper, Autoplay, A11y, Keyboard } from 'swiper';

SwiperCore.use([Navigation, Pagination, Swiper, Autoplay, A11y, Keyboard]);

const SLIDER_A11Y = {
    enabled: true,
    prevSlideMessage: 'Poprzedni slajd',
    nextSlideMessage: 'Następny slajd',
    paginationBulletMessage: 'Przejdź do slajdu {{index}}',
};

@Component({
    selector: 'app-text-carousel',
    templateUrl: './text-carousel.component.html',
    styleUrls: ['./text-carousel.component.scss']
})
export class TextCarouselComponent implements AfterViewInit, OnDestroy {
    @Input() sectionId = 'sectionDownhill';
    @Input() title = 'Odkryj tryb Downhill';
    @Input() descriptionTop = '';
    @Input() descriptionBottom = '';
    @Input() slides: { src: string; alt: string }[] = [];

    private slider?: Swiper;
    private screenWidth = window.innerWidth;

    constructor(private hostRef: ElementRef<HTMLElement>) {}

    ngAfterViewInit() {
        const host = this.hostRef.nativeElement;
        const container = host.querySelector('.swiper-container') as HTMLElement;
        const nextEl = host.querySelector('.swiper-button-next') as HTMLElement;
        const prevEl = host.querySelector('.swiper-button-prev') as HTMLElement;
        const paginationEl = host.querySelector('.swiper-pagination') as HTMLElement;
        const isDesktop = this.screenWidth >= 992;

        if (isDesktop) {
        this.slider = new Swiper(container, {
            navigation: { nextEl, prevEl },
            pagination: { el: paginationEl, clickable: true },
            slidesPerView: 1.2,
            spaceBetween: 24,
            autoplay: false,
            slidesOffsetAfter: 24,
            slidesOffsetBefore: 24,
            a11y: SLIDER_A11Y,
            keyboard: { enabled: true },
        });
        } else {
                    this.slider = new Swiper(container, {
            navigation: { nextEl, prevEl },
            pagination: { el: paginationEl, clickable: true },
            slidesPerView: 1.2,
            spaceBetween: 16,
            autoplay: false,
            slidesOffsetAfter: 24,
            slidesOffsetBefore: 24,
            a11y: SLIDER_A11Y,
            keyboard: { enabled: true },
        });
        }


    }

    ngOnDestroy() {
        if (this.slider) {
            this.slider.destroy(true, true);
        }
    }
}
